"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _ = require("../../..");
var _components = require("../../../../components");
var _utils = require("../../../../utils");
var _ApplyNoteToSessionDropdown = require("./ApplyNoteToSessionDropdown");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SectionTitle = function SectionTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("h3", {
    className: "tw-label-sm-medium text-black mb-[8px]"
  }, children);
};
var Header = function Header(_ref2) {
  var owner = _ref2.owner,
    startsAt = _ref2.startsAt,
    createdAt = _ref2.createdAt,
    user = _ref2.user;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full px-[20px] py-[12px] flex flex-wrap justify-start items-center gap-y-[4px] gap-x-[24px]"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-light"
  }, "Owner: "), /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-medium"
  }, (0, _utils.personName)(owner))), startsAt ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-light"
  }, "Appointment date: "), /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-medium"
  }, (0, _momentTimezone.default)(startsAt).tz(user.profile.timeZone).format('M.D.YYYY'))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-light"
  }, "Start time: "), /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-medium"
  }, (0, _momentTimezone.default)(startsAt).tz(user.profile.timeZone).format('h:mma')))) : /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-light"
  }, "Created on: "), /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-medium"
  }, (0, _momentTimezone.default)(createdAt).tz(user.profile.timeZone).format('M.D.YYYY h:mma')))), /*#__PURE__*/_react.default.createElement(_components.Divider, {
    className: "border-grey-15"
  }));
};
var PatientNoteUpsertDialog = function PatientNoteUpsertDialog(_ref3) {
  var note = _ref3.note,
    readonly = _ref3.readonly,
    patientId = _ref3.patientId,
    loading = _ref3.loading,
    onSubmit = _ref3.onSubmit,
    form = _ref3.form;
  var getFieldDecorator = form.getFieldDecorator;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    form.validateFieldsAndScroll(function (err, values) {
      if (!err) {
        onSubmit(values);
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "h-full w-full flex flex-col"
  }, /*#__PURE__*/_react.default.createElement(Header, {
    owner: note.creator,
    startsAt: note.startsAt,
    createdAt: note.createdAt,
    user: user
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "px-[24px] pt-[24px] pb-[40px] flex-grow h-0 overflow-auto flex flex-col gap-y-[16px]"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(SectionTitle, null, "Add a note (not shared with patient)"), getFieldDecorator('text', {
    initialValue: note === null || note === void 0 ? void 0 : note.text,
    rules: [{
      required: true
    }, {
      max: 20000,
      message: 'Note cannot be longer than 20000 characters'
    }]
  })( /*#__PURE__*/_react.default.createElement(_components.TextInput, {
    multiline: true,
    resizable: true,
    rows: 15,
    description: "Internal note about the patient. Not shown to the patient.",
    disabled: readonly
  }))), readonly && !note.summaryNoteText && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(SectionTitle, null, "Follow-up message to patient (optional)"), getFieldDecorator('summaryNoteText', {
    rules: [{
      max: 20000,
      message: 'Follow-up message cannot be longer than 20000 characters'
    }]
  })( /*#__PURE__*/_react.default.createElement(_components.TextInput, {
    multiline: true,
    resizable: true,
    rows: 5,
    description: "This will be shared with the patient.",
    disabled: readonly
  }))), /*#__PURE__*/_react.default.createElement(_.CptCodeQuestion, {
    required: false,
    form: form,
    name: "cptCodeText",
    defaultValue: note === null || note === void 0 ? void 0 : note.cptCodeText,
    disabled: readonly
  }), /*#__PURE__*/_react.default.createElement(_.IcdCodeQuestion, {
    required: false,
    form: form,
    name: "icdCodes",
    defaultValue: note === null || note === void 0 ? void 0 : note.icdCodes,
    disabled: readonly
  }), getFieldDecorator('bookingId', {
    initialValue: note === null || note === void 0 ? void 0 : note.bookingId
  })( /*#__PURE__*/_react.default.createElement(_ApplyNoteToSessionDropdown.ApplyNoteToSessionDropdown, {
    patientId: patientId,
    note: note,
    disabled: readonly
  }))), !readonly && /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full flex flex-col items-center shadow-10 py-[24px]"
  }, /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    size: "large",
    htmlType: "submit",
    className: "w-[448px]",
    disabled: loading,
    onClick: handleSubmit
  }, "Save")));
};
var _default = _form.default.create({
  name: 'PatientNoteUpsertDialog'
})(PatientNoteUpsertDialog);
exports.default = _default;